module.exports = __webpack_public_path__ + "static/media/noa_longsleeve_front.474310b7.png";